import React from 'react'
import NumberFormat from '~/Classes/numberFormatFunctions'
import Icons from '~/Common-Objects/UI/Icons/index';
import Indicator from '~/Common-Objects/UI/Indicator/index';
import Paper from '~/Common-Objects/UI/Paper/Paper';
import i18n from '~/i18n';
import { connect } from 'react-redux';

@connect((store) => {
    return {
        siteMaster: store.siteMaster
    }
})

export default class SubscribersOpened extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {

        let increaseHolder = <Indicator className="indicator-grey">0.00%</Indicator>;
        if ((this.props.opens.increase || this.props.opens.decrease) !== Infinity) {
            if (this.props.opens.increase) increaseHolder = <Indicator leftIcon={<Icons icon="arrowUp" color={this.props.siteMaster.colours["$status-green"]} />} className=" indicator-green">{NumberFormat.formatNumber(this.props.opens.increase, 2)}%</Indicator>
            if (this.props.opens.decrease) increaseHolder = <Indicator leftIcon={<Icons icon="arrowDown" color={this.props.siteMaster.colours["$status-red"]} />} className="indicator-red">{NumberFormat.formatNumber(this.props.opens.decrease, 2)}%</Indicator>
        }
        return <Paper className="m-mar-b0" iconRight={<Icons icon="pencil" color="grey" />} iconRightClick={this.props.edit}>

            <h4 className="mar-b5">{i18n.t('dashboard:welcomePage.subscriberOpens')}</h4>
            <div className="mar-b24">{i18n.t('dashboard:welcomePage.thisMonth')}</div>
            <div className="quickFlex">
                <h4 className="mar-r16 statistic">{NumberFormat.formatNumber(this.props.opens.current)}</h4>
                {increaseHolder}
                <div style={{ height: "40px" }} />
            </div>


        </Paper >
    }
}
